'use client';

import React, { useEffect } from 'react';
import { Provider, useDispatch } from 'react-redux';
import store from './store';
import { persistStore } from 'redux-persist';
import { logout } from './slices/authSlice';

persistStore(store);

function AuthListener({ children }: { children: React.ReactNode }) {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleLogout = () => {
      // Dispatch the logout action, which will trigger the rootReducer to clear global state
      dispatch(logout());
    };

    window.addEventListener('authLogout', handleLogout);
    return () => {
      window.removeEventListener('authLogout', handleLogout);
    };
  }, [dispatch]);

  return <>{children}</>;
}

export default function ReduxProvider({
  children
}: {
  children: React.ReactNode;
}) {
  return (
    <Provider store={store}>
      <AuthListener>{children}</AuthListener>
    </Provider>
  );
}
